import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=504f83f4&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=ts"
export * from "./VideoUpload.vue?vue&type=script&lang=ts"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=504f83f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f83f4",
  null
  
)

export default component.exports